import React from 'react';

import { useGetPremiumPayById } from 'queries';

import { convertToNumber } from 'utils/converters';

import { FormComponentProps } from 'components/shared/CRUD/TableCRUDLayout';

import FormSkeleton from './components/FormSkeleton';

import PremiumPayForm from './PremiumPayForm';

const CreateOrEditPremiumPay: React.FC<FormComponentProps> = ({
  handleClose,
  rowId
}) => {
  const { isFetching, data } = useGetPremiumPayById(convertToNumber(rowId));

  return isFetching ? (
    <FormSkeleton />
  ) : (
    <PremiumPayForm handleClose={handleClose} rowData={data} />
  );
};

export default CreateOrEditPremiumPay;
